import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var statusCodes = {
  401: 'unauthorized',
  404: 'not_found',
  422: 'unprocessable_entity'
};
var defaultStatusCode = 'unknown';
var getCode = function getCode(status, data) {
  if (data && typeof data === 'object' && 'statusCode' in data) {
    return data.statusCode;
  }
  if (status && statusCodes[status]) {
    return statusCodes[status];
  }
  return defaultStatusCode;
};
var getMessage = function getMessage(errorMessage, data) {
  if (data && typeof data === 'object') {
    if ('message' in data) return data.message;
    if ('error' in data) return data.error;
  }
  return errorMessage;
};
var getErrors = function getErrors(data) {
  if (data && typeof data === 'object' && 'errors' in data) {
    return data.errors;
  }
  return undefined;
};
var OMSError = /*#__PURE__*/function (_Error) {
  _inherits(OMSError, _Error);
  var _super = _createSuper(OMSError);
  function OMSError(errorMessage, status, data) {
    var _this;
    _classCallCheck(this, OMSError);
    var code = getCode(status, data);
    var message = getMessage(errorMessage, data);
    var errors = getErrors(data);
    _this = _super.call(this, message);
    _defineProperty(_assertThisInitialized(_this), "code", void 0);
    _defineProperty(_assertThisInitialized(_this), "errors", void 0);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), OMSError);
    }
    _this.name = 'OMSError';
    _this.code = code;
    if (errors) _this.errors = errors;
    return _this;
  }
  return _createClass(OMSError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export default OMSError;